import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import StandardSection from '../c/StandardSection/StandardSection'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

const wrapMQ = css(mq({
  paddingTop: [
    40, // 0+
    40, // 440+
    64, // 768+
    80, // 1024+
    80, // 1200+
    132, // 1400+
  ],
}))

export const Wrap = styled(StandardSection)`
  ${wrapMQ}
`

const contentMQ = css(mq({
  gap: [
    32, // 0+
    32, // 440+
    32, // 768+
    32, // 1024+
    40, // 1200+
    64, // 1400+
  ],
}))

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  ${contentMQ}
`

export const TitleWrap = styled.div`
  max-width: 620px;
`

const titleMQ = css(mq({
  font: [
    "var(--accent-770)", // 0+
    "var(--accent-770)", // 440+
    "var(--accent-970)", // 768+
    "var(--accent-1070)", // 1024+
  ],
}))

export const Title = styled.h2`
  color: var(--color-grayscale-900);

  & > ins {
    color: var(--color-positive-700);
    text-decoration: none;
  }

  ${titleMQ}
`
